/* PILLAR custom Quick Add
   Premium quick view matched to the prior MBN/Symmetry theme aesthetic:
   editorial image-left layout, square corners, charcoal #343131, light-grey
   size chips (#dde0eb), outlined Add-to-Cart. Intercepts .quickbuy-toggle,
   reads /products/<handle>.js, adds via /cart/add.js. */
(function () {
  if (window.__pqaInit) return;
  window.__pqaInit = true;

  var INK = '#343131', CHIP = '#dde0eb', LINE = '#e4e1da';
  var css = [
    '#pqa-modal{position:fixed;inset:0;z-index:100000;display:none;font-family:inherit;color:' + INK + ';}',
    '#pqa-modal[aria-hidden="false"]{display:block;}',
    '#pqa-modal .pqa-overlay{position:absolute;inset:0;background:rgba(20,18,17,.55);animation:pqaFade .25s ease;}',
    '#pqa-modal .pqa-panel{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:calc(100% - 48px);max-width:640px;max-height:88vh;overflow:auto;background:#fff;box-shadow:0 34px 90px rgba(0,0,0,.3);animation:pqaPop .3s cubic-bezier(.2,.7,.2,1);}',
    '@keyframes pqaFade{from{opacity:0}to{opacity:1}}',
    '@keyframes pqaPop{from{opacity:0;transform:translate(-50%,-47%)}to{opacity:1;transform:translate(-50%,-50%)}}',
    '#pqa-modal .pqa-x{position:absolute;top:0;right:0;width:46px;height:46px;display:flex;align-items:center;justify-content:center;border:0;background:none;font-size:24px;line-height:1;cursor:pointer;color:' + INK + ';opacity:.6;z-index:2;transition:opacity .15s;}',
    '#pqa-modal .pqa-x:hover{opacity:1;}',
    '#pqa-modal .pqa-grid{display:flex;align-items:stretch;}',
    '#pqa-modal .pqa-media{flex:none;width:244px;background:#f4f3ef;}',
    '#pqa-modal .pqa-media img{width:100%;height:100%;object-fit:cover;display:block;}',
    '#pqa-modal .pqa-info{flex:1;padding:34px 34px 32px;min-width:0;}',
    '#pqa-modal .pqa-title{font-size:1.32rem;font-weight:600;letter-spacing:-.01em;line-height:1.15;}',
    '#pqa-modal .pqa-price{margin-top:8px;font-size:1.02rem;font-weight:500;}',
    '#pqa-modal .pqa-rule{height:1px;background:' + LINE + ';margin:22px 0;}',
    '#pqa-modal .pqa-opt{margin-bottom:22px;}',
    '#pqa-modal .pqa-opt-name{font-size:.72rem;letter-spacing:.16em;text-transform:uppercase;font-weight:700;margin-bottom:11px;}',
    '#pqa-modal .pqa-opt-name span{font-weight:500;opacity:.6;margin-left:6px;letter-spacing:.02em;text-transform:none;}',
    '#pqa-modal .pqa-opt-vals{display:flex;flex-wrap:wrap;gap:9px;}',
    '#pqa-modal .pqa-val{min-width:46px;height:46px;padding:0 14px;display:inline-flex;align-items:center;justify-content:center;border:0;background:' + CHIP + ';color:' + INK + ';cursor:pointer;font-size:.84rem;font-weight:600;letter-spacing:.02em;transition:background .15s,color .15s,box-shadow .15s;}',
    '#pqa-modal .pqa-val:hover{box-shadow:inset 0 0 0 1.5px ' + INK + ';}',
    '#pqa-modal .pqa-val.is-sel{background:' + INK + ';color:#fff;}',
    '#pqa-modal .pqa-val.is-un{background:#f3f2ee;color:#b4b0a8;text-decoration:line-through;cursor:not-allowed;box-shadow:none;}',
    '#pqa-modal .pqa-add{width:100%;margin-top:6px;padding:16px 24px;border:1.5px solid ' + INK + ' !important;background:#fff !important;color:' + INK + ' !important;font-size:.86rem;font-weight:600;letter-spacing:.02em;cursor:pointer;transition:background .18s,color .18s,opacity .18s;}',
    '#pqa-modal .pqa-add:not([disabled]):hover{background:' + INK + ' !important;color:#fff !important;}',
    '#pqa-modal .pqa-add[disabled]{opacity:.4;cursor:not-allowed;background:#fff !important;color:' + INK + ' !important;border-color:' + INK + ' !important;}',
    '#pqa-modal .pqa-add.is-added{background:' + INK + ' !important;color:#fff !important;}',
    '#pqa-modal .pqa-msg{margin-top:11px;font-size:.82rem;color:#a3361f;min-height:1em;}',
    '#pqa-modal .pqa-loading{padding:70px 0;text-align:center;opacity:.5;letter-spacing:.05em;}',
    '#pqa-modal .pqa-view{display:inline-block;margin-top:16px;font-size:.72rem;letter-spacing:.13em;text-transform:uppercase;color:' + INK + ';opacity:.6;text-decoration:none;border-bottom:1px solid currentColor;padding-bottom:2px;transition:opacity .15s;}',
    '#pqa-modal .pqa-view:hover{opacity:1;}',
    '@media(max-width:620px){#pqa-modal .pqa-panel{left:0;right:0;bottom:0;top:auto;transform:none;width:100%;max-width:none;max-height:92vh;animation:pqaUp .32s cubic-bezier(.2,.7,.2,1);}@keyframes pqaUp{from{transform:translateY(100%)}to{transform:translateY(0)}}#pqa-modal .pqa-grid{flex-direction:column;}#pqa-modal .pqa-media{width:100%;height:200px;}#pqa-modal .pqa-info{padding:24px 22px calc(24px + env(safe-area-inset-bottom));}#pqa-modal .pqa-title{font-size:1.18rem;}}',
    'html.pqa-lock{overflow:hidden;}'
  ].join('');
  var st = document.createElement('style');
  st.id = 'pqa-css';
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  var modal;
  function money(c) { return '$' + (Math.round(c) / 100).toFixed(2).replace(/\.00$/, ''); }

  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'pqa-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = '<div class="pqa-overlay" data-pqa-close></div><div class="pqa-panel" role="dialog" aria-modal="true" aria-label="Quick add"><button class="pqa-x" type="button" aria-label="Close" data-pqa-close>×</button><div class="pqa-body"></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.hasAttribute && t.hasAttribute('data-pqa-close')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) close();
    });
    return modal;
  }
  function open() { ensureModal(); modal.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('pqa-lock'); }
  function close() { if (modal) { modal.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('pqa-lock'); } }

  function valueAvailable(product, oi, val, selected) {
    return product.variants.some(function (v) {
      if (!v.available) return false;
      if (v.options[oi] !== val) return false;
      return selected.every(function (s, i) { return i === oi || s === null || v.options[i] === s; });
    });
  }
  function currentVariant(product, selected) {
    if (!selected.every(function (s) { return s !== null; })) return null;
    return product.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === selected[i]; });
    }) || null;
  }

  function render(product, fallbackUrl) {
    var body = modal.querySelector('.pqa-body');
    var img = product.featured_image || (product.images && product.images[0]) || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;

    var optNames = product.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
    var values = optNames.map(function (_, i) {
      var set = [];
      product.variants.forEach(function (v) { if (set.indexOf(v.options[i]) < 0) set.push(v.options[i]); });
      return set;
    });
    var isDefault = product.variants.length === 1 && optNames.length === 1 && optNames[0] === 'Title';
    var selected = optNames.map(function () { return null; });
    values.forEach(function (vals, i) { if (vals.length === 1) selected[i] = vals[0]; });

    var optsHtml = '';
    if (!isDefault) {
      optsHtml += '<div class="pqa-rule"></div>';
      optNames.forEach(function (name, oi) {
        if (values[oi].length <= 1) return;
        optsHtml += '<div class="pqa-opt"><div class="pqa-opt-name">' + name + '<span data-pqa-chosen="' + oi + '"></span></div><div class="pqa-opt-vals">';
        values[oi].forEach(function (val) {
          optsHtml += '<button type="button" class="pqa-val" data-oi="' + oi + '" data-val="' + String(val).replace(/"/g, '&quot;') + '">' + val + '</button>';
        });
        optsHtml += '</div></div>';
      });
    }

    body.innerHTML =
      '<div class="pqa-grid">' +
        (img ? '<div class="pqa-media"><img src="' + img + '" alt=""></div>' : '') +
        '<div class="pqa-info">' +
          '<div class="pqa-title">' + product.title + '</div>' +
          '<div class="pqa-price" data-pqa-price>' + money(product.price) + '</div>' +
          optsHtml +
          (isDefault ? '<div class="pqa-rule"></div>' : '') +
          '<button type="button" class="pqa-add" data-pqa-add disabled>Select a size</button>' +
          '<div class="pqa-msg" data-pqa-msg></div>' +
          '<a class="pqa-view" href="' + fallbackUrl + '">View full details</a>' +
        '</div>' +
      '</div>';

    function refresh() {
      body.querySelectorAll('.pqa-val').forEach(function (btn) {
        var oi = +btn.getAttribute('data-oi'), val = btn.getAttribute('data-val');
        btn.classList.toggle('is-sel', selected[oi] === val);
        btn.classList.toggle('is-un', !valueAvailable(product, oi, val, selected));
      });
      body.querySelectorAll('[data-pqa-chosen]').forEach(function (s) {
        var oi = +s.getAttribute('data-pqa-chosen');
        s.textContent = selected[oi] ? selected[oi] : '';
      });
      var addBtn = body.querySelector('[data-pqa-add]');
      var ready = selected.every(function (s) { return s !== null; });
      var v = ready ? currentVariant(product, selected) : null;
      addBtn.classList.remove('is-added');
      if (!ready) { addBtn.disabled = true; addBtn.textContent = 'Select a size'; addBtn.removeAttribute('data-vid'); }
      else if (!v || !v.available) { addBtn.disabled = true; addBtn.textContent = 'Sold out'; addBtn.removeAttribute('data-vid'); }
      else { addBtn.disabled = false; addBtn.textContent = 'Add to Cart — ' + money(v.price); addBtn.setAttribute('data-vid', v.id); body.querySelector('[data-pqa-price]').textContent = money(v.price); }
    }
    body.querySelectorAll('.pqa-val').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-un')) return;
        selected[+btn.getAttribute('data-oi')] = btn.getAttribute('data-val');
        refresh();
      });
    });
    refresh();

    body.querySelector('[data-pqa-add]').addEventListener('click', function () {
      var id = this.getAttribute('data-vid');
      if (!id) return;
      var addBtn = this, msg = body.querySelector('[data-pqa-msg]');
      msg.textContent = '';
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: +id, quantity: 1 }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { addBtn.disabled = false; addBtn.textContent = 'Try again'; msg.textContent = (res.j && (res.j.description || res.j.message)) || 'Could not add to cart'; return; }
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('.cart-link__count,.cart-count,.header__cart-count,[class*="cart"] [class*="count"]').forEach(function (e) {
              if (/^\s*\d*\s*$/.test(e.textContent)) e.textContent = cart.item_count;
            });
          });
          addBtn.classList.add('is-added');
          addBtn.textContent = 'Added to Cart ✓';
          setTimeout(function () { close(); refreshCartDrawer(); }, 750);
        })
        .catch(function () { addBtn.disabled = false; addBtn.textContent = 'Try again'; msg.textContent = 'Something went wrong. Please try again.'; });
    });
  }

  function openCartDrawer() {
    var m = document.querySelector('.cart-drawer-modal');
    if (m) { m.classList.add('cc-popup--visible'); m.setAttribute('aria-hidden', 'false'); }
    document.documentElement.classList.add('cc-popup-open');
    try { document.dispatchEvent(new CustomEvent('cart:updated')); document.dispatchEvent(new CustomEvent('cart:refresh')); document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
  }

  function refreshCartDrawer() {
    var current = document.querySelector('[data-section-type="cart-drawer"]');
    var sid = current && current.getAttribute('data-section-id');
    if (!current || !sid) { openCartDrawer(); return; }
    fetch('/?section_id=' + encodeURIComponent(sid), { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-section-type="cart-drawer"]') || tmp.firstElementChild;
        var cur = document.querySelector('[data-section-type="cart-drawer"]');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        openCartDrawer();
      })
      .catch(openCartDrawer);
  }

  function openQuickAdd(toggle) {
    var url = toggle.getAttribute('href') || '';
    var handle = url.split('?')[0].replace(/\/+$/, '').split('/').pop();
    if (!handle) { if (url) window.location = url; return; }
    ensureModal();
    open();
    modal.querySelector('.pqa-body').innerHTML = '<div class="pqa-loading">Loading…</div>';
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) { render(p, url); })
      .catch(function () { window.location = url; });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.quickbuy-toggle');
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openQuickAdd(t);
  }, true);
})();
